import { createContext, useContext } from 'react'

import { Job } from 'types/Job'

const context = createContext<Job | null>(null)
export const useLiveJobsContext = (): Job | null => useContext(context)
export default context
